import routes from '@/constants/routes'

/**
 * Mapping of DatoCMS content type names to their URL route prefixes.
 */
export const CONTENT_TYPE_ROUTES: Record<string, string> = {
  DatoCmsPctPaper: routes.paperRoute,
  DatoCmsPctPost: routes.postRoute,
  DatoCmsPctInterview: routes.interviewRoute,
  DatoCmsPctDialog: routes.dialogRoute,
  DatoCmsPctPage: routes.pageRoute,
  DatoCmsPctTag: routes.tagRoute,
  DatoCmsPctTopic: routes.topicRoute,
  DatoCmsPctProject: routes.projectRoute,
  DatoCmsPctInternalPage: routes.internalPageRoute,
  DatoCmsPctEpisode: routes.episodeRoute,
  DatoCmsGctPerson: routes.personRoute,
  DatoCmsPctReport: routes.reportRoute,
  DatoCmsPctEvent: routes.eventRoute,
  DatoCmsPctVision: routes.pageRoute,
  DatoCmsPctExternalContent: ''
} as const
